// Construit une URL iClosed avec UTM tracking pour identifier la source du clic
const ICLOSED_BASE = "https://app.iclosed.io/e/HORSEPOWER/accompagnement-horsepower";

export function iclosedUrl(campaign = "general", extra = {}) {
  const params = new URLSearchParams({
    utm_source: "horsepower-academy",
    utm_medium: "site",
    utm_campaign: campaign,
    ...extra,
  });
  return `${ICLOSED_BASE}?${params.toString()}`;
}

export const ICLOSED_URL = ICLOSED_BASE; // export brut au cas où
